import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRadio = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8341 12.0642C10.8341 10.6198 11.4452 9.34201 12.3896 8.39756C12.5563 8.2309 12.5563 7.95312 12.3896 7.7309C12.223 7.56423 11.8896 7.56423 11.723 7.7309C10.6119 8.84201 9.88965 10.342 9.88965 12.0642C9.88965 13.7309 10.6119 15.2865 11.723 16.3976C11.8896 16.5642 12.223 16.5642 12.3896 16.3976C12.5563 16.2309 12.5563 15.9531 12.3896 15.7309C11.4452 14.7865 10.8341 13.5087 10.8341 12.0642Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.2777 7.7309C20.111 7.56423 19.7777 7.56423 19.611 7.7309C19.4443 7.89756 19.4443 8.17534 19.611 8.39756C20.5554 9.34201 21.1666 10.6198 21.1666 12.0642C21.1666 13.5087 20.5554 14.7865 19.611 15.7309C19.4443 15.8976 19.4443 16.1753 19.611 16.3976C19.7777 16.5642 20.111 16.5642 20.2777 16.3976C21.3888 15.2865 22.111 13.7865 22.111 12.0642C22.111 10.3976 21.3888 8.84201 20.2777 7.7309Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.6522 12.0786C17.6522 12.8008 17.2078 13.4119 16.5411 13.6341V18.4499C16.7292 18.552 16.8921 18.7121 17.0011 18.9304L19.4125 23.7617C19.7812 24.5005 19.244 25.3691 18.4183 25.3691H13.5955C12.7699 25.3691 12.2326 24.5005 12.6014 23.7617L15.0128 18.9304C15.1134 18.7288 15.26 18.5768 15.43 18.4743V13.6341C14.7633 13.4119 14.3189 13.023 14.3189 12.0786C14.3189 11.1341 15.0411 10.4119 15.9856 10.4119C16.93 10.4119 17.6522 11.3563 17.6522 12.0786Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3892 8.95268C18.6122 8.72972 18.9543 8.822 19.1267 9.04384C19.9601 9.82162 20.3892 10.9527 20.3892 12.1749C20.3892 13.3971 19.8892 14.5082 19.0559 15.286C18.8892 15.4527 18.5559 15.4527 18.3892 15.286C18.2225 15.0638 18.2225 14.786 18.3892 14.6194C19.0559 13.9527 19.4448 13.1194 19.4448 12.1194C19.4448 11.1194 19.0559 10.2305 18.3892 9.61935C18.2225 9.39713 18.2225 9.11935 18.3892 8.95268Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9461 8.95268C13.1127 8.78602 13.4461 8.78602 13.6127 8.95268C13.682 9.02331 13.8188 9.30217 13.6127 9.50824C12.9461 10.1749 12.5572 11.0082 12.5572 12.0082C12.5572 13.0082 12.9461 13.8971 13.6127 14.5082C13.7794 14.7305 13.7794 15.0082 13.6127 15.1749C13.4461 15.3416 13.1127 15.3416 12.9461 15.1749C12.1127 14.3971 11.6127 13.286 11.6127 12.0638C11.6127 10.8416 12.1127 9.73046 12.9461 8.95268Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.628 19.5264C15.7825 19.2229 16.216 19.2229 16.3705 19.5264L18.6772 24.0558C18.8184 24.333 18.617 24.6616 18.3059 24.6616H13.6926C13.3815 24.6616 13.1801 24.333 13.3213 24.0558L15.628 19.5264Z",
			fill: "#6393F2"
		})
	]
});
export default SvgRadio;
